import './style.scss';
import { config } from './utils/functions';

document.addEventListener('DOMContentLoaded', () => {
	const panoramaEls = document.querySelectorAll('.wp-block-bpgb-panorama');
	panoramaEls.forEach(panoramaEl => {
		const attributes = JSON.parse(panoramaEl.dataset.attributes);

		const containerEl = document.querySelector(`#${panoramaEl.id} .bpgbPanorama`);

		config(attributes, containerEl);

		panoramaEl?.removeAttribute('data-attributes');
	});
});